import React from 'react';
import { Modal, Button, Spinner, Alert, Table, Row, Col, Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Assuming Link might be useful here

function BulkPreviewFatturaModal({ show, handleClose, previews, onConfirm, loadingConfirm, confirmError, selectedOrdersTotal }) {

  return (
    <Modal show={show} onHide={handleClose} size="xl" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Anteprima Fatture Selezionate</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {confirmError && <Alert variant="danger">{confirmError}</Alert>}
        
        {previews.length === 0 && !confirmError && (
            <Alert variant="warning">Nessuna anteprima disponibile. Seleziona degli ordini per generare l'anteprima.</Alert>
        )}

        <p>Stai per creare <strong>{previews.length}</strong> fatture per un importo totale di <strong>€ {selectedOrdersTotal.toFixed(2)}</strong>.</p>
        <p>Verifica le anteprime qui sotto:</p>

        <Accordion defaultActiveKey="0">
          {previews.map((preview, index) => (
            <Accordion.Item eventKey={String(index)} key={preview.ordine_id || index}>
              <Accordion.Header>
                {preview.error ? (
                    <span className="text-danger">
                        Ordine ID: {preview.ordine_id} - Errore: {preview.error}
                    </span>
                ) : (
                    <>
                        Ordine ID: {preview.ordine_id} - Cliente: {preview.cliente.denominazione_sociale || `${preview.cliente.nome} ${preview.cliente.cognome}`} - Totale: € {preview.documento.totale.toFixed(2)}
                    </>
                )}
              </Accordion.Header>
              <Accordion.Body>
                {preview.error ? (
                  <Alert variant="danger">
                    <p><strong>Errore per l'Ordine ID {preview.ordine_id}:</strong></p>
                    <p>{preview.error}</p>
                    {preview.status_code && <p>Codice di stato: {preview.status_code}</p>}
                    <Link to={`/ordini/${preview.ordine_id}`} onClick={handleClose}>Vai all'ordine</Link>
                  </Alert>
                ) : (
                  <div>
                    <Row className="mb-2">
                      <Col>
                        <strong>Fattura N. (proposto):</strong> {preview.documento.numero}
                        <br />
                        <strong>Data:</strong> {new Date(preview.documento.data).toLocaleDateString()}
                      </Col>
                      <Col>
                        <strong>Cliente:</strong> {preview.cliente.denominazione_sociale || `${preview.cliente.nome} ${preview.cliente.cognome}`}<br/>
                        {preview.cliente.indirizzo}, {preview.cliente.cap} {preview.cliente.citta} ({preview.cliente.provincia})<br/>
                        {preview.cliente.piva && `P.IVA: ${preview.cliente.piva}`}{preview.cliente.cf && ` / CF: ${preview.cliente.cf}`}
                      </Col>
                    </Row>
                    
                    <Table striped bordered hover responsive size="sm">
                      <thead>
                        <tr>
                          <th>Codice</th>
                          <th>Descrizione</th>
                          <th className="text-end">Qtà</th>
                          <th className="text-end">Prezzo Unit.</th>
                          <th className="text-end">IVA %</th>
                          <th className="text-end">Imponibile</th>
                        </tr>
                      </thead>
                      <tbody>
                        {preview.documento.righe.map((riga, rigaIndex) => (
                          <tr key={rigaIndex}>
                            <td>{riga.codice}</td>
                            <td>{riga.descrizione}</td>
                            <td className="text-end">{riga.qty}</td>
                            <td className="text-end">€ {riga.prezzo.toFixed(2)}</td>
                            <td className="text-end">{riga.iva}%</td>
                            <td className="text-end">€ {riga.imponibile.toFixed(2)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>

                    <Row className="justify-content-end text-end mt-2">
                        <Col md={5}>
                            <p className="mb-0"><strong>Imponibile:</strong> € {preview.documento.imponibile.toFixed(2)}</p>
                            <p className="mb-0"><strong>IVA:</strong> € {preview.documento.iva.toFixed(2)}</p>
                            <p className="mb-0"><strong>Spese Spedizione:</strong> € {preview.documento.spese_spedizione.toFixed(2)}</p>
                            <hr className="my-1"/>
                            <h6 className="mb-0"><strong>Totale Documento:</strong> € {preview.documento.totale.toFixed(2)}</h6>
                            <p className="mb-0"><strong>Acconto:</strong> € {preview.documento.acconto.toFixed(2)}</p>
                            <h6 className="mb-0"><strong>Saldo:</strong> € {(preview.documento.totale - preview.documento.acconto).toFixed(2)}</h6>
                        </Col>
                    </Row>
                     {preview.documento.note && (
                        <Row className="mt-2">
                            <Col>
                                <strong>Note:</strong> {preview.documento.note}
                            </Col>
                        </Row>
                    )}
                  </div>
                )}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Annulla
        </Button>
        <Button variant="success" onClick={onConfirm} disabled={loadingConfirm || previews.some(p => p.error)}>
          {loadingConfirm ? <Spinner as="span" animation="border" size="sm" /> : 'Conferma e Crea Tutte'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default BulkPreviewFatturaModal;